// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-61cf4b7a] .scrolling-content{padding-top:200px}@media only screen and (min-width: 960px){[data-v-61cf4b7a] .scrolling-content{padding-top:15vh}}@media only screen and (max-width: 959px){[data-v-61cf4b7a] .clip-mask{opacity:1;top:80px}[data-v-61cf4b7a] .clip-mask p{font-size:12vw}}", ""]);
// Exports
module.exports = exports;
